import {
  Button,
  Flex,
  Text,
  useMantineTheme,
  Loader,
  ActionIcon,
} from "@mantine/core";
import TextInput from "src/components/TextInput/TextInput";
import { useState } from "react";
import { MdClose } from "react-icons/md";
import { useCheckEmployeePinLazyQuery } from "src/generated/graphql";
import { ModalStages } from "src/utils/constants";

interface DeviceUnlockProps {
  setCurrentModalStage: (e: ModalStages) => void;
  handleModalClose: () => void;
}

const DeviceUnlock = ({
  setCurrentModalStage,
  handleModalClose,
}: DeviceUnlockProps) => {
  const theme = useMantineTheme();
  const [unlockID, setUnlockID] = useState<string>("");

  const [confirmPin, { loading }] = useCheckEmployeePinLazyQuery({
    onCompleted(data) {
      data.checkEmployeePin && setCurrentModalStage(ModalStages.PAYMENTMETHOD);
    },
  });

  const handleUnlock = () => {
    confirmPin({ variables: { pin: unlockID } });
  };

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (/^\d*$/.test(event.target.value)) {
      setUnlockID(event.target.value);
    }
  };

  return (
    <div
      style={{
        width: "100%",
        minHeight: 500,
        display: "flex",
        flexDirection: "column",
        borderRadius: 4,
      }}
    >
      <Flex
        align={"center"}
        justify={"flex-start"}
        style={{
          padding: "10px 20px",
          marginBottom: "10px",
          borderBottom: `2px solid ${theme.colors.light[5]}`,
        }}
      >
        <Text size={22} fw={500}>
          Sign Policies
        </Text>
      </Flex>
      <Flex
        direction={"column"}
        align={"center"}
        style={{
          margin: "10px 20px",
          padding: 10,
          width: "90%",
          borderRadius: 4,
          backgroundColor: theme.colors.secondary[6],
        }}
      >
        <Text size={15} fw={400} px={10}>
          Your agreement documents have been successfully signed.
          <br />
          Please return the device to your assisting staff member to continue
          enrollment.
        </Text>
        <TextInput
          w={"95%"}
          my={15}
          placeholder="Staff Unlock ID"
          maxLength={4}
          value={unlockID}
          onChange={handleInputChange}
        />
        {/* </div> */}
      </Flex>
      <Flex
        direction={"column"}
        align={"center"}
        style={{
          position: "absolute",
          bottom: 0,
          left: 0,
          margin: "20px",
          width: "90%",
        }}
      >
        <Button
          radius="lg"
          variant="filled"
          onClick={handleUnlock}
          w={"100%"}
          sx={{
            color: theme.colors.primaryTextColor[6],
            "&:hover": {
              backgroundColor: theme.colors.primary[4],
            },
          }}
          loading={loading}
          disabled={unlockID.length !== 4}
        >
          Unlock Device
        </Button>
      </Flex>
    </div>
  );
};

export default DeviceUnlock;
